/** @jsx jsx */
import { jsx } from '@emotion/core';
import React from 'react';
import { Label } from '@myob/myob-widgets';
import { EBillsStatus } from 'modules/MyBills';

export type Props = {
    status: EBillsStatus | undefined;
};

export const InvoiceStatus: React.FC<Props> = ({ status }) => {
    switch (status) {
        case EBillsStatus.Paid:
            return (
                <Label type="boxed" color="green">
                    Paid
                </Label>
            );
        case EBillsStatus.DueNow:
            return (
                <Label type="boxed" color="red">
                    Due now
                </Label>
            );
        case EBillsStatus.Credited:
            return (
                <Label type="boxed" color="green">
                    Credited
                </Label>
            );
        default:
            return null;
    }
};

export default InvoiceStatus;
